import { lazy } from "react";

export { SURVEY_EDITOR_PARTICIPANT_RESULT_PATH } from "./survey-editor-participant-result-path";
export const SurveyEditorParticipantResult = lazy(
  () => import("./survey-editor-participant-result"),
);

export { ToSurveyEditorParticipantResult } from "./to-survey-editor-participant-result";
